import { memo } from "react"

const IconArrowUpGreen = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.0391 4.75C12.0391 4.55109 11.96 4.36032 11.8194 4.21967C11.6787 4.07902 11.488 4 11.2891 4H5.27906C5.08015 4 4.88938 4.07902 4.74873 4.21967C4.60808 4.36032 4.52906 4.55109 4.52906 4.75C4.52906 4.94891 4.60808 5.13968 4.74873 5.28033C4.88938 5.42098 5.08015 5.5 5.27906 5.5H9.47906L4.21906 10.76C4.08238 10.9014 4.00669 11.0908 4.0083 11.2875C4.00992 11.4841 4.08871 11.6722 4.2277 11.8114C4.36669 11.9505 4.55476 12.0295 4.75141 12.0313C4.94806 12.0331 5.13755 11.9576 5.27906 11.821L10.5391 6.561V10.761C10.5391 10.9599 10.6181 11.1507 10.7587 11.2913C10.8994 11.432 11.0902 11.511 11.2891 11.511C11.488 11.511 11.6787 11.432 11.8194 11.2913C11.96 11.1507 12.0391 10.9599 12.0391 10.761V4.75Z"
        fill="#1EA672"
      />
    </svg>
  )
}

export default memo(IconArrowUpGreen)
